import React from 'react'

const HorizontalRule = () => {
  return <hr className="my-2 border-third w-full mx-auto" />
}

export default HorizontalRule
